import { useMutation } from '@tanstack/react-query';

import { apiClient } from '@services/apiClient';

const userActivityLogFn = ({ userId }) => {
  return apiClient.get(`${APP_SSO_URL}api/user-profile/activity-log-csv`, {
    params: {
      user_id: userId,
    },
  });
};

export const useUserActivityLogMutation = () => {
  return useMutation({
    mutationFn: userActivityLogFn,
  });
};
